import { render } from "./Breadcrumbs.vue?vue&type=template&id=39055a73"
import script from "./Breadcrumbs.vue?vue&type=script&setup=true&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/navigation/Breadcrumbs/Breadcrumbs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39055a73"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39055a73', __exports__)) {
    api.reload('39055a73', __exports__)
  }
  
  module.hot.accept("./Breadcrumbs.vue?vue&type=template&id=39055a73", () => {
    api.rerender('39055a73', render)
  })

}


export default __exports__